import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Home from './pages/Home';
import Login from './pages/Login';
import Signup from './pages/Signup';
import BusinessProfile from './pages/BusinessProfile';
import ManagerDashboard from './pages/ManagerDashboard';
import GenerateReview from './pages/GenerateReview';
import AdminPanel from './pages/AdminPanel';

function App() {
  return (
    <Router>
      <Routes>
        {/* Review page without header/footer */}
        <Route path="/review/:managerId" element={<GenerateReview />} />
        
        {/* All other pages with header/footer */}
        <Route path="/*" element={
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/business-profile" element={<BusinessProfile />} />
              <Route path="/managers" element={<ManagerDashboard />} />
              <Route path="/admin" element={<AdminPanel />} />
            </Routes>
          </Layout>
        } />
      </Routes>
    </Router>
  );
}

export default App;
